import { ref } from 'vue'
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router'
import { closeGateLogin } from '@/composables/useGatePanel'
import {
  closeLandingGate,
  isPortalOrgId,
  portalOrgType,
  setPortalOrgType,
  type PortalOrgId,
} from '@/composables/useOrgType'

const STORAGE_KEY = 'portal.loginReturnOrg'

function readStoredReturn(): PortalOrgId | null {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY)
    return isPortalOrgId(value) ? value : null
  } catch {
    return null
  }
}

function writeStoredReturn(id: PortalOrgId | null) {
  try {
    if (id) sessionStorage.setItem(STORAGE_KEY, id)
    else sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* private mode 등 */
  }
}

const loginReturnOrg = ref<PortalOrgId | null>(readStoredReturn())

export function rememberLoginReturnOrg() {
  const id = portalOrgType.value
  if (!isPortalOrgId(id)) return
  loginReturnOrg.value = id
  writeStoredReturn(id)
}

export function clearLoginReturnOrg() {
  loginReturnOrg.value = null
  writeStoredReturn(null)
}

export function consumeLoginReturnOrg(): PortalOrgId | null {
  const id = loginReturnOrg.value ?? readStoredReturn()
  clearLoginReturnOrg()
  return isPortalOrgId(id) ? id : null
}

/** 카카오 리다이렉트·가드용. 로그인 뒤엔 검은 메인으로 돌아간다. */
export function memberHomeAfterLogin(): string {
  return '/'
}

/** 로그인 성공 후 사업구분을 맞추고, 이동할 경로를 돌려준다. */
export function applyMemberHomeAfterLogin(): string {
  const org = consumeLoginReturnOrg() ?? portalOrgType.value
  closeGateLogin()
  closeLandingGate()
  if (isPortalOrgId(org)) {
    setPortalOrgType(org)
  }
  return '/'
}

/** 헤더·드로어 로그인: 로그인 페이지로 보낸다. */
export function goPortalLogin(router: Router, route: RouteLocationNormalizedLoaded) {
  if (route.name === 'login') return
  const redirect = route.fullPath && route.name !== 'login' ? route.fullPath : ''
  void router.push({ name: 'login', query: redirect ? { redirect } : {} })
}
